import { colors } from '@shared/interfaces/paleta-cores';

export const optionsChartDesvio: Highcharts.Options = {
	chart: {
		type: 'column',
		backgroundColor: 'transparent',
	},
	colors: colors,
	plotOptions: {
		column: {
			borderWidth: 0,
		},
	},
};
